//  ---------------------------------------------------------------------------
//  DO NOT EDIT THIS FILE! This File was auto-generated.
//  ---------------------------------------------------------------------------
define('root/Assets/Js/Templates',[
	'root/Assets/Templates/Container/Onepicture/Js/Onepicture',
	'root/Assets/Templates/Container/Slider/Js/Slider',
	'root/Assets/Templates/Container/Textelement/Js/Textelement',
	'root/Assets/Templates/Container/Textelementlarge/Js/Textelementlarge',
	'root/Assets/Templates/Container/Threepictures/Js/Threepictures',
	'root/Assets/Templates/Container/Twopictures/Js/Twopictures',
	'root/Assets/Templates/Container/Twotext/Js/Twotext'
], function () {
	return arguments;
});

